import { useMediaQuery } from "@mui/material";

const useIsMobile = () => {
  return useMediaQuery("(max-width:599px)");
};

export default useIsMobile;
